// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7ff4bfda","703":"aebb34cd"}[chunkId] + ".chunk.js";
};